import styled from 'styled-components';
import { useImpactChartFontSizes, useImpactChartHeights, useImpactChartWidths } from '../context';
import { Text } from './shared';

const SVG = styled.svg``;

export function ColumnTitlesRowMobile() {
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const { columnTitles } = useImpactChartFontSizes();
  const style = {
    fontSize: columnTitles,
  };
  return (
    <SVG height={heights.columnTitlesRow} width={widths.full} style={{ display: 'block' }}>
      <g transform={`translate(0, ${heights.columnTitlesRow / 2})`}>
        <Text x={widths.titleTextPadding} dy="0.35em" style={style}>
          Impact
        </Text>
        <Text x={widths.title + widths.bars + widths.middle / 2} dy="0.35em" textAnchor="middle" style={style}>
          Score
        </Text>
      </g>
    </SVG>
  );
}
